// Appointment values are stored as "08:00", "08:00-12:00", "FCFS", "FCFS 07:00-15:00" or "Open".
export const parseAppt = (v) => {
  const s = (v || "").trim();
  if (!s) return { kind: "", start: "", end: "" };
  const m = s.match(/^(FCFS|Open)?\s*(?:(\d{2}:\d{2})(?:-(\d{2}:\d{2}))?)?$/);
  if (!m) return { kind: "", start: "", end: "" };
  const [, word, start = "", end = ""] = m;
  if (word === "FCFS") return { kind: "fcfs", start, end };
  if (word === "Open") return { kind: "open", start: "", end: "" };
  return { kind: end ? "window" : "time", start, end };
};

export const formatAppt = ({ kind, start, end }) => {
  if (kind === "open") return "Open";
  if (kind === "fcfs") return start && end ? `FCFS ${start}-${end}` : "FCFS";
  if (kind === "window") return start && end ? `${start}-${end}` : "";
  if (kind === "time") return start || "";
  return "";
};

const to12 = (hm) => {
  const [h, m] = hm.split(":").map(Number);
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};

export const describeAppt = (v) => {
  const { kind, start, end } = parseAppt(v);
  if (kind === "open") return "Open — no set time";
  if (kind === "fcfs") return start && end ? `FCFS ${to12(start)} – ${to12(end)}` : "FCFS (first come, first served)";
  if (kind === "window") return `Window ${to12(start)} – ${to12(end)}`;
  if (kind === "time") return `Appt ${to12(start)}`;
  return "";
};
